class TrendingSearchPills extends HTMLElement {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.mobileMediaQuery = window.matchMedia('(max-width: 1023.98px)');
  }

  connectedCallback() {
    this.list = this.querySelector('[data-trending-search-list]');
    this.progress = this.querySelector('[data-trending-search-progress]');
    this.bar = this.querySelector('[data-trending-search-progress-bar]');

    if (!this.list || !this.progress || !this.bar) return;

    this.list.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('resize', this.handleResize);
    this.mobileMediaQuery.addEventListener('change', this.handleResize);

    this.drawer = this.closest('search-drawer');
    if (this.drawer) {
      this.openObserver = new MutationObserver(() => {
        if (this.drawer.hasAttribute('open')) {
          requestAnimationFrame(() => this.updateProgress());
        }
      });
      this.openObserver.observe(this.drawer, { attributes: true, attributeFilter: ['open'] });
    }

    this.handleResize();
  }

  disconnectedCallback() {
    this.list?.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
    this.mobileMediaQuery.removeEventListener('change', this.handleResize);
    this.openObserver?.disconnect();
  }

  isMobile() {
    return this.mobileMediaQuery.matches;
  }

  handleScroll() {
    this.updateProgress();
  }

  handleResize() {
    this.updateProgress();
  }

  updateProgress() {
    if (!this.isMobile()) {
      this.progress.hidden = true;
      return;
    }

    const maxScroll = this.list.scrollWidth - this.list.clientWidth;

    if (maxScroll <= 1) {
      this.progress.hidden = true;
      this.bar.style.width = '';
      this.bar.style.transform = '';
      return;
    }

    this.progress.hidden = false;

    const trackWidth = this.progress.clientWidth;
    const thumbWidth = Math.max((this.list.clientWidth / this.list.scrollWidth) * trackWidth, trackWidth * 0.25);
    const maxTranslate = trackWidth - thumbWidth;
    const scrollRatio = this.list.scrollLeft / maxScroll;

    this.bar.style.width = `${thumbWidth}px`;
    this.bar.style.transform = `translateX(${scrollRatio * maxTranslate}px)`;
  }
}

if (!customElements.get('trending-search-pills')) {
  customElements.define('trending-search-pills', TrendingSearchPills);
}
